export const CAMPAIGN = {
  TRIP: "ret_worldcuptrip_contest",
  SHIRT: "ret_worldcupshirt_contest",
};
export const RECAPTCHA_KEY =
  `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod"
    ? "6LfX050lAAAAAFcmcOy1KdiEi2k5bBrmqWptug1V"
    : "6LekoJ0lAAAAAHv_IXXvHAPqt43_lzzyXf61h0fV";

export const recaptchaActions = {
  RETARGETING: "retargeting_collect",
};
